module.exports = __webpack_public_path__ + "img/dummyprod2@1x.08bce3a2.png";